import { Controller } from '@hotwired/stimulus';

import ajax from '@/modules/ajax';
import notify from '@/modules/notify';
import Scanner from '@/modules/scanner';

export default class extends Controller {
  connect() {
    this.email = document.querySelector('[data-email]');
    this.event = document.querySelector('[data-event]');
    this.icon = document.querySelector('[data-icon]');
    this.id = document.querySelector('[data-id]');
    this.info = document.querySelector('[data-info]');
    this.name = document.querySelector('[data-name]');
    this.scanner = Scanner.init();
    this.scanner.onStop = () => this.#restore();
    this.scanner.onStopError = (error) => this.#onScannerStopError(error);
    this.startButton = document.querySelector('[data-start]');
    this.stopButton = document.querySelector('[data-stop]');
    this.wrapper = document.querySelector('[data-wrapper]');

    this.startButton.addEventListener('click', () => this.#onStart());
    this.stopButton.addEventListener('click', () => this.#onStop());
  }

  #onScan(url) {
    ajax({
      done: (json) => this.#onScanDone(json),
      fail: (json) => this.#onScanFail(json),
      method: 'PUT',
      url: url,
    });
  }

  #onScanDone(json) {
    this.email.innerText = json.ticket.email;
    this.event.innerText = json.event.name;
    this.id.innerText = json.ticket.id;
    this.name.innerText = json.ticket.name;

    this.stopButton.classList.add('hidden');
    this.startButton.classList.remove('hidden');
    this.info.classList.remove('hidden');
  }

  #onScanFail(json) {
    const error = json.responseJSON?.error;

    if (error) {
      notify({ title: error });

      this.#onStop();
    }
  }

  #onScannerStopError(error) {
    notify({ title: error });

    this.#restore();
  }

  #onStart() {
    this.startButton.classList.add('hidden');
    this.info.classList.add('hidden');
    this.stopButton.classList.remove('hidden');

    this.scanner.start((url) => this.#onScan(url));
  }

  #onStop() {
    this.scanner.stop();
  }

  #restore() {
    this.stopButton.classList.add('hidden');
    this.startButton.classList.remove('hidden');

    this.wrapper.append(this.icon);
  }
}
